// @flow
import React, { Component } from "react";
import { prettyDate } from "../../../utils/helpers";
import SeverityRating from "../../shared/SeverityRating/SeverityRating";
import Tag from "./Tag/Tag";
import styles from "./BreachInfo.module.css";

type Props = {
  breach: PrismicBreach
};

type State = {};

class BreachInfo extends Component<Props, State> {
  get renderPartiesInvolved() {
    const { breach } = this.props;
    const { data } = breach;
    const breachedCompany = {
      name: breach.data.company_name,
      url: breach.data.company_url
    };
    const parties = [breachedCompany, ...data.parties_involved];
    return parties.map(this.renderParty);
  }

  renderParty = (
    party: { name: string, url?: { url: string } },
    index: number
  ) => {
    const { breach } = this.props;
    const { data } = breach;
    if (party.url && party.name) {
      return [
        <a
          href={party.url.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.plainLink}
        >
          {party.name}
        </a>,
        `${index < data.parties_involved.length ? `, ` : ``}`
      ];
    }
    if (party.name) {
      return `${party.name}${index < data.parties_involved.length ? `, ` : ``}`;
    }
  };

  render() {
    const { breach } = this.props;
    const { data } = breach;
    return (
      <div className={styles.wrapper}>
        <div className={styles.section}>
          <span className={styles.label}>Parties Involved</span>
          {this.renderPartiesInvolved}
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Severity</span>
          <SeverityRating severity={data.severity} showLabel />
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Disclosed Publicly</span>
          <span className={styles.infoText}>
            {prettyDate(data.disclosed_at)}
          </span>
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Initial Discovery</span>
          <span className={styles.infoText}>
            {prettyDate(data.discovered_at)}
          </span>
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Leaked Information</span>
          <span className={styles.infoText}>{data.leaked_information || "n/a"}</span>
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Attack Vector</span>
          <span className={styles.infoText}>{data.attack_vector || "n/a"}</span>
        </div>
        <div className={styles.tagSection}>
          <span className={styles.label}>Tags</span>
          <div className={styles.tagGrid}>
            {data.tags.map(({ tag }) => (
              <Tag key={tag} tag={tag} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default BreachInfo;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachInfo/BreachInfo.js